{
	"accountsPayable": "Contas a pagar",
	"accountsReceivable": "Contas a receber",
	"providers": "Gestão de parceiros",
	"costCenter": "Centro de Custo",
	"planAccounts": "Plano de Contas",
	"checkingAccount": "Conta Corrente",
	"reports": "Relatórios",
	"cashflow": "Fluxo de caixa",
	"finExManagerialReport": "DRE",
	"bankAccounts": "Contas bancárias",
	"noticeIsFreeModule": "Módulo gratuito até",
	"conciliation": "Conciliação via OFX",
	"eventConference": "Conferência de eventos"
}
